import { P2GBox } from '@parcel2go/core-ui';
import ActionMenuContent from '~/apps/smartsend/components/smartsend/sidepanel/action-menu-content';
import { EventSections } from '~/apps/smartsend/lib/events/EventLogger';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { lazy, Suspense } from 'react';
import { SettingsCache } from '~/lib/consts/settings-cache';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';
const VipDetails = lazy(() => import('./vip'));

export const NavSidebar = ({ currentPageRoute }: { currentPageRoute: string }) => {
  const { track } = useSmartSendAnalytics();

  const logEvent = (link: string) => {
    track({
      type: 'navigation_shortcut_used',
      payload: GenerateBaseAnalyticsPayload([EventSections.MyAccount, EventSections.NavigationSidebar], {
        surface: 'navigation-sidebar',
        action: 'navigation-shortcut',
        link
      })
    });
  };

  return (
    <P2GBox
      sx={(t) => ({
        backgroundColor: 'white',
        height: '100%',
        padding: t.spacing(4, 3),
        border: '1px solid #E0E0E0',
        boxShadow: `10px 0px 2px 0px ${t.palette.grey.A200}`,
        minWidth: '280px'
      })}
    >
      <ActionMenuContent logEvent={logEvent} currentPageRoute={currentPageRoute} showFullMenuStructure={false} />
      {SettingsCache.settings.Features.includes('VipSupport') && (
        <Suspense>
          <VipDetails
            isWidget
            wrapper={(x) => <P2GBox sx={{ px: { xs: 0, sm: 2 }, py: 4, width: '250px' }}>{x}</P2GBox>}
          />
        </Suspense>
      )}
    </P2GBox>
  );
};
